import PropTypes from 'prop-types';

import DefaultTableResize from '@/components/DefaultTableResize';
import { formatDateTime } from '@Utils/index';

import { nullableFormatter, winnerIconFormatter, sweepFormatter, winnerFormatter, winnerStatusFormatter } from './formatters';

const propTypes = {
  data: PropTypes.array,
};

export const COLUMNS = [{
  dataField: "id",
  formatter: winnerIconFormatter,
  text: '',
}, {
  dataField: "sweepId",
  formatter: sweepFormatter,
  text: 'Sweep',
}, {
  dataField: "contestId",
  text: 'Contest Number',
}, {
  dataField: "winnerTicket",
  text: 'Ticket',
}, {
  dataField: "winnerFound",
  formatter: winnerFormatter,
  text: 'Winner',
}, {
  dataField: "winnerStatus",
  formatter: nullableFormatter(winnerStatusFormatter),
  text: 'Status',
}, {
  dataField: "drawType",
  text: 'Draw Type',
}, {
  dataField: "createdAt",
  formatter: formatDateTime,
  text: 'Drawn Date',
}, {
  dataField: "sweepSubscription.createdAt",
  formatter: nullableFormatter(formatDateTime),
  text: 'Fulfillment Date',
}, {
  dataField: "sweepCycle.endsAt",
  formatter: formatDateTime,
  text: 'Contest End Date',
}]

const SweepWinnerTable = ({ data }) => {
  if (!data) {
    return <div className='font-semibold text-center'>Please select a site in configure section.</div>
  }

  return <>
    <DefaultTableResize
      keyField='id'
      data={data}
      noDataIndication={() => 'No content to show.'}
      columns={COLUMNS}
    />
  </>
}

SweepWinnerTable.propTypes = propTypes;

export default SweepWinnerTable;
